import { BlockProps } from './types';
import styled from 'styled-components';
import { ToggleLocalNotification } from 'components/ToggleLocalNotification';

const Container = styled.div`
  display: flex;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
`;

export const NotificationTogglerBlock = ({ currentVehicle }: BlockProps) => {
  return (
    <Container>
      <ToggleLocalNotification vehicle={currentVehicle} />
    </Container>
  );
};
